/**
 * Created by rmarquez on 06/12/2017.
 */

import Immutable    from 'immutable';
import restService  from 'RestService.js';
import constants    from 'Constants.js';
import undoService from 'UndoService';
import listService from 'ListService';
import eventBus  from 'EventBus.js';
import textConstants        from 'TextConstants';
import NotificationService from "./NotificationService";

//===========================================================================================
// This service creates a new report folder on the host.
//===========================================================================================
class ReportFolderService {
    //===========================================================================================
    // This method creates a new report folder on the host.
    //
    // The name of the report folder will be "New Folder", unless a report folder of that name exists for this user.
    // In that case the name is "New Folder (n)" where 'n' is the highest member of an increasing
    // sequence of 'n'.
    //
    // Return  object: 
    //
    //===========================================================================================
    newReportFolder(newFormReportObjectParameters) {
        let parametersToSend = {
            name: newFormReportObjectParameters.name,
            groupTypeId: newFormReportObjectParameters.groupTypeId,
            groupParentId: newFormReportObjectParameters.groupParentId
        };

        return new Promise((resolve, reject) => {
            this._newReportFolder(parametersToSend).then(result => {
                let reportFolderId = result.reportFolderId;
                undoService.add({
                    undo: () => {
                        restService.deleteReportFolder(reportFolderId).then(response => {
                            eventBus.trigger('deletingReport', reportFolderId, true);});
                        
                    },
                    redo: () => {
                        this.newReportFolder(parametersToSend).then(result => {
                            eventBus.trigger('undeletingReportFolder', parametersToSend.groupTypeId, parametersToSend.groupParentId,newFormReportObjectParameters.selectedNodeTarget,newFormReportObjectParameters.isAddedOnRoot,  result);
                        });
                    }
                }, textConstants.UNDO_NEW_FORM_FOLDER);
                resolve(result);
            }).catch(reject);
        });
    }

    _newReportFolder(reportFolderDTO){
        return new Promise((resolve, reject) => {
            // Build request
            // Carry out request
            restService.addReportFolder(reportFolderDTO).then(data => {
                const goodMsg = `Report Folder "${data.Name}", ID "${data.GroupId}" created.`;
                const itemId = data.GroupId +'-' + data.reportFolderId;
                let result = {  msg: goodMsg, reportFolderId: data.GroupId, name: data.Name,
                    groupType: data.GroupId, itemId: itemId  };
                resolve(result);
            }, err => {
                if (err && typeof err === 'string') {
                    reject(err);
                } else if (err && typeof err === 'object' && err.responseText) {
                    const msg = JSON.parse(err.responseText);
                    reject(`${msg.Message}. ${msg.ExceptionMessage}.`);
                } else {
                    reject(err);
                }
            });
        });
    }

    deleteReportFolder(name, groupId, groupTypeId, groupParentId) {
        return new Promise((resolve, reject) => {
            this._deleteReportFolder(name, groupId ,groupTypeId, groupParentId).then(result => {
                undoService.add({
                    undo: () => {
                        this._unDeleteReportFolder(groupId).then(data =>{
                            if(listService.activeDashboardTab === 'reports') {
                                eventBus.trigger('undoReportFolder', data.name, data.groupId, data.groupTypeId, data.parentId, data.msg);
                            }
                            else{
                                NotificationService.success(`Folder ${name} was deleted. Clicking undo restores it.`);
                            }
                        });
                    },
                    redo: () => {
                        this._deleteReportFolder(name, groupId ,groupTypeId, groupParentId).then(result => {
                            if(listService.activeDashboardTab === 'reports') {
                                eventBus.trigger('deletingReport', groupId, true);
                            }
                            else{
                                NotificationService.success(`Folder ${name} was deleted. Clicking undo restores it.`);
                            }
                        });
                    }
                }, textConstants.UNDO_DELETE_REPORT_FOLDER);
                resolve(result);
            }).catch(reject);
        });
    }

    _deleteReportFolder(name, groupId, groupTypeId,groupParentId) {
        return new Promise((resolve, reject) => {
            // Build request
            // Carry out request

            restService.deleteReportFolder(groupId).then(data => {
                const goodMsg = `Report Folder "${name}", ID "${groupId}" deleted.`;
                let result = {
                    msg: goodMsg, reportFolderId: groupId, name: name,
                    groupType: groupTypeId, itemId: groupParentId
                };
                resolve(result);
            }, err => {
                if (err && typeof err === 'string') {
                    reject(err);
                } else if (err && typeof err === 'object' && err.responseText) {
                    const msg = JSON.parse(err.responseText);
                    reject(`${msg.Message}. ${msg.ExceptionMessage}.`);
                } else {
                    reject(err);
                }
            });
        });
    }

    _unDeleteReportFolder(groupId, folderName='') {
        return new Promise((resolve, reject) => {
            // Build request
            // Carry out request
            restService.unDeleteFormFolder(groupId).then(data => {
                const goodMsg = `Report Folder "${data.Name}" , was restored.`;
                let result = {
                    msg: goodMsg, groupId: groupId, name: data.Name,
                    groupTypeId: data.GroupTypeId, parentId: data.GroupParentId
                };
                resolve(result);
            }, err => {
                if (err && typeof err === 'string') {
                    reject(err);
                } else if (err && typeof err === 'object' && err.responseText) {
                    const msg = JSON.parse(err.responseText);
                    reject(`${msg.Message}. ${msg.ExceptionMessage}.`);
                } else {
                    reject(err);
                }
            });
        });
    }

}

const reportFolderService = new ReportFolderService();
export default reportFolderService;
